export default "https://cdn-static-staging.gokick.com/assets/8a9bc5ae92c259feb7c9591453bfa6ace937db28/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";